import React from 'react'
import { Box, Table, Anchor, Paper, Image, Text, Badge, Menu, ActionIcon } from '@mantine/core'
import { IconDotsVertical, IconPencil, IconTrash, IconAB2, IconShare, IconPhoto, IconChecklist, IconPencilDollar } from '@tabler/icons-react'
import dayjs from 'dayjs'
import NoImage from '../../../assets/img/images/no-images.png'
import { useNavigate } from 'react-router-dom'

const ActionMenu = ({ handleAction, detail }) => {
  return (
    <Menu width={200} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={14} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={11}
        >
          Edit
        </Menu.Item>
        <Menu.Item
          leftSection={<IconPencilDollar stroke={1.5} size={14} />}
          onClick={() => handleAction('editPrice')}
          fw='600'
          fz={11}
        >
          Set Price
        </Menu.Item>
        <Menu.Item
          leftSection={<IconPhoto stroke={1.5} size={14} />}
          onClick={() => handleAction('uploadImage')}
          fw='600'
          fz={11}
        >
          Upload Image
        </Menu.Item>
        <Menu.Item
          leftSection={<IconChecklist stroke={1.5} size={14} />}
          onClick={() => handleAction('attachDocument')}
          fw='600'
          fz={11}
        >
          Attach Document
        </Menu.Item>
        <Menu.Item
          leftSection={<IconAB2 stroke={1.5} size={14} />}
          onClick={() => handleAction('changeStatus')}
          fw='600'
          fz={11}
        >
          Change Status
        </Menu.Item>
        <Menu.Item
          leftSection={<IconShare stroke={1.5} size={14} />}
          onClick={() => handleAction('shareLink')}
          fw='600'
          fz={11}
        >
          Share Link
        </Menu.Item>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const TableProductQuote = ({ label, data, actionMethod }) => {
  const navigate = useNavigate()

  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {

    const toDetailUser = (dataUser) => {
      if (dataUser !== null) {
        navigate(`/users/${dataUser.id}`)
      }
    }

    return (
      <Table.Tr key={index}>
        <Table.Td>{val.id}</Table.Td>
        <Table.Td>
          <Paper shadow="sm" w={62} withBorder radius='md'  style={{ cursor: 'pointer' }}>
            <Image w={60} h={60} radius='md' src={val.image !== null ? val.image : NoImage} />
          </Paper>
        </Table.Td>
        <Table.Td>
          <Box h={40}>
            <Text fz={13} lineClamp={2}>{val.product_name}</Text>
          </Box>
        </Table.Td>
        <Table.Td><Badge variant="light" color="black" tt='uppercase' w={120} fz={11} fw='500'>{val.quote_type}</Badge></Table.Td>
        <Table.Td>
          <Box>
            <Anchor fz={13} underline="hover" c={val.user !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.user)}>{val.user !== null ? val.user.name : 'No User'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.created_at).format('DD/MMMM/YYYY')} - { dayjs(val.created_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td>
          <Box>
            <Anchor fz={13} underline="hover" c={val.creator !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.creator)}>{val.creator !== null ? val.creator.name : 'No User'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.created_at).format('DD/MMMM/YYYY')} - { dayjs(val.created_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td>
          <Box>
            <Anchor fz={13} underline="hover" c={val.updater !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.updater)}>{val.updater !== null ? val.updater.name : 'No User'}</Anchor>
            <Text fz={10} c='gray.6'>{dayjs(val.updated_at).format('DD/MMMM/YYYY')} - { dayjs(val.updated_at).format('HH:mm:ss')}</Text>
          </Box>
        </Table.Td>
        <Table.Td><Badge variant="light" color="black" tt='capitalize' w={110} fz={11} fw='500'>{val.status.length > 0 ? val.status[0].name : '-'}</Badge></Table.Td>
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} detail={val} /></Table.Td>
      </Table.Tr>
    )
  })
  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default TableProductQuote